import { render, staticRenderFns } from "./FrameSelections.vue?vue&type=template&id=252ff452&"
import script from "./FrameSelections.vue?vue&type=script&lang=js&"
export * from "./FrameSelections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports